import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmManageStatusModal({ open, onClose, statuses = [], onAdd, onRemove }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#6366f1");

  const canAdd = useMemo(() => name.trim().length > 0, [name]);

  const add = () => {
    if (!canAdd) return;
    onAdd?.({ name: name.trim(), color });
    setName("");
    setColor("#6366f1");
  };

  return (
    <RfmModalBase
      open={open}
      title="Gestionar Estados"
      onClose={onClose}
      footer={
        <>
          <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>Cerrar</button>
          <button className="rfm-btn rfm-btn-primary" type="button" onClick={add} disabled={!canAdd}>
            <i className="bi bi-plus-lg" /> Agregar
          </button>
        </>
      }
    >
      <div>
        {statuses.map((s, i) => (
          <div
            key={s.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.6rem",
              padding: "0.4rem",
              background: "var(--bg-tertiary)",
              borderRadius: 6,
              marginBottom: "0.4rem",
            }}
          >
            <div style={{ width: 16, height: 16, borderRadius: "50%", background: s.color }} />
            <span style={{ flex: 1, fontSize: "0.85rem" }}>{s.name}</span>

            {i >= 3 ? (
              <button
                className="rfm-btn rfm-btn-icon rfm-btn-secondary"
                type="button"
                style={{ width: 26, height: 26 }}
                onClick={() => onRemove?.(s.id)}
              >
                <i className="bi bi-trash" style={{ fontSize: "0.7rem" }} />
              </button>
            ) : null}
          </div>
        ))}
      </div>

      <hr style={{ margin: "0.75rem 0", borderColor: "var(--border-color)" }} />

      <div className="rfm-form-row">
        <input className="rfm-form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre" />
        <input className="rfm-form-input" type="color" value={color} onChange={(e) => setColor(e.target.value)} style={{ padding: "0.2rem", height: 38, width: 50 }} />
      </div>
    </RfmModalBase>
  );
}
